$bog_bzrl_app_step $mol_view
	sub /
		<= Number $mol_view
			sub /
				<= number 0
		<= Icon $mol_view
			sub /
				<= icon null
		<= Title $mol_paragraph
			title <= title \
		<= Description $mol_paragraph
			title <= description \

$bog_bzrl_app_step_match $bog_bzrl_app_step
	number 1
	icon <= Icon_match $mol_icon_magnify
	title @ \matching system
	description @ \Browse all listings and mark what you like. Your profile (together with the renter) appears in the owner's candidate list.

$bog_bzrl_app_step_request $bog_bzrl_app_step
	number 2
	icon <= Icon_request $mol_icon_email_outline
	title @ \submit a request
	description @ \We pass your details to the owner and arrange free contact. We charge the lowest commission on the market: 20% of one month's rent.

$bog_bzrl_app_step_pay $bog_bzrl_app_step
	number 3
	icon <= Icon_pay $mol_icon_currency_rub
	title @ \apartment payment
	description @ \After payment, we pass your details to the landlord and help finalize the agreement.
